import { render, staticRenderFns } from "./OrdersCountWidget.vue?vue&type=template&id=700c9c64&"
import script from "./OrdersCountWidget.vue?vue&type=script&lang=js&"
export * from "./OrdersCountWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports